import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IAdministrativeComplaintView } from 'app/models/mainMenu/mainMenu';
import { IActionableStatus } from 'app/models/complaints/complaints';
import { IBusinessView } from 'app/models/business/business';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({ providedIn: 'root' })
export class ProcessComplaintService {

  currentBusiness: IBusinessView;
  businessList: IBusinessView[] = [];
  businessAdminSearch: string = '';
  userSearch: string = '';
  complaintId: number = 0;

  public apiProcessComplaint: string = environment.privateApi + 'processComplaint/';


  private http = inject(HttpClient);

  // Proccess Complaint 

  getComplaintData(id: number): Observable<IAdministrativeComplaintView> {
    return this.http.get<IAdministrativeComplaintView>(this.apiProcessComplaint + 'getComplaintData/' + id);
  }

  refineSearch(id:number, countyId:string, searchText: string): Observable<IAdministrativeComplaintView> {
    searchText = searchText.replace('/', '%2F');
    return this.http.get<IAdministrativeComplaintView>(this.apiProcessComplaint + 'refineSearch/' +id +
        '/' + countyId + '/' + searchText);
  }
  
  associateBusiness(id:number, associatedBusinessId:string): Observable<boolean> {
    return this.http.get<boolean>(this.apiProcessComplaint + 'associateBusiness/' +id +
        '/' + associatedBusinessId );
  }
  
  getAdditionalComplaints(id:number): Observable<IAdministrativeComplaintView[]> {
    return this.http.get<IAdministrativeComplaintView[]>(this.apiProcessComplaint + 'getAdditionalComplaints/' + id);
  }

  setActionableStatus(model: IActionableStatus): Observable<boolean> {
    return this.http.post<boolean>(this.apiProcessComplaint + 'setActionableStatus', model);
  }

  saveNewBusiness(model: IBusinessView): Observable<boolean> {
    return this.http.post<boolean>(this.apiProcessComplaint + 'saveNewBusiness', model);
  }

}
